enum ContactStatus {
    New = 'new',
    Engaged = 'engaged',
    Thanked = 'thanked',
    Incomplete = 'incomplete',
}

export default ContactStatus;
